import { ReactNode } from 'react'
import { useIntl } from 'react-intl'
import { Button } from 'primereact/button'
import { ProgressSpinner } from 'primereact/progressspinner'
import { SectionStatus } from '../useSectionData'

interface UrgencyDaySectionProps {
  id: string
  title: string
  status: SectionStatus
  /** Texto cuando la consulta de la sección falló: dice qué no se pudo ver. */
  failedMessageId: string
  onRetry: () => void
  children: ReactNode
}

/**
 * Una sección del panel del día con su propia carga y su propio error: el spinner mientras llega, y si la consulta falla,
 * una nota con «Reintentar» (el resto del panel sigue funcionando). Con datos, muestra su contenido.
 */
export default function UrgencyDaySection({ id, title, status, failedMessageId, onRetry, children }: UrgencyDaySectionProps) {
  const intl = useIntl()
  return (
    <section className="nv-urg-detail__section" aria-labelledby={id}>
      <h3 className="nv-section-title" id={id}>{title}</h3>
      {status === 'loading' && (
        <span className="nv-loading nv-urg-detail__loading" role="status">
          <ProgressSpinner strokeWidth="4" style={{ width: 16, height: 16 }} />
          <span>{intl.formatMessage({ id: 'UrgencySummaryLoading' })}</span>
        </span>
      )}
      {status === 'failed' && (
        <div className="nv-urg-failed" role="status">
          <p className="nv-note">
            <i className="pi pi-info-circle" aria-hidden="true" />
            {intl.formatMessage({ id: failedMessageId })}
          </p>
          <Button type="button" link label={intl.formatMessage({ id: 'UrgencySummaryRetry' })} onClick={onRetry} />
        </div>
      )}
      {status === 'ready' && children}
    </section>
  )
}
